import * as types from "../ActionType";
import axios from "axios";
import {
  notifyError,
  notifysuccess,
  notifyErrorNetWork,
} from "../../Components/General/Notification";
import { base_url } from "../../Components/General/Notification";
import { hasRout } from "../../Components/General/UseRout";

const addProduct = () => {
  return {
    type: types.ADD_PRODUCT,
  };
};
const AddMarketingTool = () => {
  return {
    type: types.ADD_MARKETINGtOOL,
  };
};
const getProduct = (product) => {
  return {
    type: types.GET_PRODUCT,
    payload: product,
  };
};
const getMarketingTools = (marketingTool) => {
  return {
    type: types.GET_MARKETING_TOOLS,
    payload: marketingTool,
  };
};
const delProduct = () => {
  return {
    type: types.DELETE_PRODUCT,
  };
};
const delTool = () => {
  return {
    type: types.DELETE_TOOL,
  };
};
const editProduct = () => {
  return {
    type: types.EDIT_PRODUCT,
  };
};

export const loadProduct = (navigate, setopenInternet) => {
  return function (dispatch) {
    let token = localStorage.getItem("tokenMiamed");
    axios
      .get(`${base_url}api/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch(getProduct(res.data.data));
      })
      .catch((err) => {
        hasRout(err.response.status, navigate);
        if (err.message == "Network Error" || err.message) {
          setopenInternet(true);
        }
      });
  };
};
export const loadMarketingTools = (navigate, setopenInternet) => {
  return function (dispatch) {
    let token = localStorage.getItem("tokenMiamed");
    axios
      .get(`${base_url}api/products?filter[product_type]=marketing_tools`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        // dispatch(getProduct(res.data.data));
        dispatch(getMarketingTools(res.data.data));
      })
      .catch((err) => {
        hasRout(err.response.status, navigate);
        if (err.message == "Network Error" || err.message) {
          setopenInternet(true);
        }
      });
  };
};

export const postProduct = (
  name,
  description,
  internal_reference,
  product_category_id,
  measurement_unit_id,
  color,
  product_type,
  image,
  setLoad,
  setOpen
) => {
  return function (dispatch) {
    setLoad(true);
    let token = localStorage.getItem("tokenMiamed");
    const Dataa = new FormData();
    Dataa.append("name", name);
    Dataa.append("description", description);
    Dataa.append("internal_reference", internal_reference);
    Dataa.append("product_category_id", product_category_id);
    Dataa.append("measurement_unit_id", measurement_unit_id);
    Dataa.append("color", color);
    Dataa.append("product_type", "medicine_samples");
    Dataa.append("image", image);
    axios
      .post(`${base_url}api/products`, Dataa, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch(addProduct());
        if (res.data.status == "Success") {
          notifysuccess(res.data.message);

          dispatch(loadProduct());
          setLoad(false);
          setOpen(false);
        }
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        setLoad(false);
      });
  };
};
export const postMarketingTools = (
  name,
  description,
  code,
  product_category_id,
  measurement_unit_id,
  color,
  product_type,
  image,
  setLoad,
  setOpen
) => {
  return function (dispatch) {
    setLoad(true);
    let token = localStorage.getItem("tokenMiamed");
    const Dataa = new FormData();
    Dataa.append("name", name);
    Dataa.append("description", description);
    Dataa.append("code", code);
    // Dataa.append("product_category_id", product_category_id);
    Dataa.append("measurement_unit_id", measurement_unit_id);
    Dataa.append("color", color);
    Dataa.append("product_type", "marketing_tools");
    Dataa.append("image", image);
    axios
      .post(`${base_url}api/products`, Dataa, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch(AddMarketingTool());
        if (res.data.status == "Success") {
          notifysuccess(res.data.message);
          // dispatch(getProduct(res.data.data));
          // dispatch(loadProduct());
          dispatch(loadMarketingTools());
          // dispatch(
          //   loadFilterProduct(
          //     measurement_unit_id,
          //     "marketing_tools",
          //     product_category_id,
          //     setLoad
          //   )
          // );
          setLoad(false);
          setOpen(false);
        }
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        setLoad(false);
      });
  };
};
export const deleteProduct = (id, setdeletee, setloadDel) => {
  return function (dispatch) {
    let token = localStorage.getItem("tokenMiamed");
    setloadDel(true);
    axios
      .delete(`${base_url}api/products/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status == "Success") {
          notifysuccess(res.data.message);
          dispatch(delProduct());
          dispatch(getMarketingTools(res.data.data));

          dispatch(loadProduct());
          setdeletee(false);
          setloadDel(false);
        }
      })
      .catch((err) => {
        setdeletee(false);
        notifyError(err.response.data.message);
        setloadDel(false);
      });
  };
};
export const deleteTool = (id, setdeletee, setloadDel) => {
  return function (dispatch) {
    let token = localStorage.getItem("tokenMiamed");
    setloadDel(true);
    axios
      .delete(`${base_url}api/marketing-tools/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status == "Success") {
          notifysuccess(res.data.message);
          dispatch(delTool());
          dispatch(loadMarketingTools());
          setdeletee(false);
          setloadDel(false);
        }
      })
      .catch((err) => {
        setdeletee(false);
        notifyError(err.response.data.message);
        setloadDel(false);
      });
  };
};

export const putProduct = (
  id,
  name,
  description,
  internal_reference,
  product_category_id,
  measurement_unit_id,
  color,
  product_type,
  image,
  setLoad,
  setOpen
) => {
  return function (dispatch) {
    setLoad(true);
    let token = localStorage.getItem("tokenMiamed");
    const Dataa = new FormData();

    if (name !== "") Dataa.append("name", name);
    if (description !== "") Dataa.append("description", description);
    if (internal_reference !== "")
      Dataa.append("internal_reference", internal_reference);
    if (product_category_id !== "")
      Dataa.append("product_category_id", product_category_id);
    if (measurement_unit_id !== "")
      Dataa.append("measurement_unit_id", measurement_unit_id);
    if (color !== "") Dataa.append("color", color);
    if (product_type !== "") Dataa.append("product_type", product_type);
    if (image !== "") Dataa.append("image", image);

    axios
      .post(`${base_url}api/products/${id}`, Dataa, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch(editProduct());
        if (res.data.status === "Success") {
          notifysuccess(res.data.message);
          dispatch(getMarketingTools(res.data.data));

          dispatch(loadProduct());
          setLoad(false);
          setOpen(false);
        }
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        setLoad(false);
      });
  };
};
export const putMar = (
  id,
  name,
  description,
  internal_reference,
  color,
  product_type,
  image,
  setLoad,
  setOpen
) => {
  return function (dispatch) {
    setLoad(true);
    let token = localStorage.getItem("tokenMiamed");
    const Dataa = new FormData();

    if (name !== "") Dataa.append("name", name);
    if (description !== "") Dataa.append("description", description);

    if (color !== "") Dataa.append("color", color);
    if (product_type !== "") Dataa.append("product_type", product_type);
    if (image !== "") Dataa.append("image", image);
    if (internal_reference !== "") Dataa.append("code", internal_reference);

    axios
      .post(`${base_url}api/products/${id}`, Dataa, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch(editProduct());
        if (res.data.status === "Success") {
          notifysuccess(res.data.message);
          dispatch(loadMarketingTools());
          setOpen(false);
          setLoad(false);
        }
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        setLoad(false);
      });
  };
};

export const loadFilterProduct = (
  measurement_unit_id,
  product_type,
  search_value,
  product_category_id,
  setLoad
) => {
  return function (dispatch) {
    setLoad(true);
    let token = localStorage.getItem("tokenMiamed");
    axios
      .get(
        `${base_url}api/products?filter[measurement_unit_id]=${measurement_unit_id}&filter[product_type]=${product_type}&filter[search_value]=${search_value}&filter[product_category_id]=${product_category_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        dispatch(getProduct(res.data.data));
        setLoad(false);
      })
      .catch((err) => {
        setLoad(false);
      });
  };
};
export const loadFilterMar = (
  measurement_unit_id,
  product_type,
  search_value,
  product_category_id,
  setLoad
) => {
  return function (dispatch) {
    setLoad(true);
    let token = localStorage.getItem("tokenMiamed");
    axios
      .get(
        `${base_url}api/products?filter[measurement_unit_id]=${measurement_unit_id}&filter[product_type]=${product_type}&filter[search_value]=${search_value}&filter[product_category_id]=${product_category_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        dispatch(getMarketingTools(res.data.data));
        setLoad(false);
      })
      .catch((err) => {
        setLoad(false);
      });
  };
};
